import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Modal } from '@deseretbook/react-ui'
import { Slices } from '../../prismic'

/**
 * Successfully created view of the subscription signup modal.
 *
 * @returns {function} Component
 */
const SuccessView = ({ detailsDocument, user }) => (
  <Fragment>
    <Modal.Content>
      <Slices
        slices={detailsDocument && detailsDocument.data && detailsDocument.data.successSlices}
        user={user}
      />
    </Modal.Content>
  </Fragment>
)

SuccessView.propTypes = {
  detailsDocument: PropTypes.shape({
    data: PropTypes.shape({
      successSlices: PropTypes.array,
    }),
  }),
  user: PropTypes.shape({}),
}

SuccessView.defaultProps = {
  detailsDocument: {},
  user: null,
}

export default SuccessView
